export const getStatusCode = err => err && err.response && err.response.status
export const errorCodeIn = (err, codes) => codes.includes(getStatusCode(err))
